import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  onVideoLoad?: () => void;
}
export function HeroSection({
  onVideoLoad
}: HeroSectionProps) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const handleIframeLoad = () => {
    setTimeout(() => {
      setVideoLoaded(true);
      onVideoLoad?.();
    }, 1000);
  };
  return <main className="overflow-x-hidden bg-black" data-id="element-116">
      <section className="relative h-screen" data-id="element-117">
        <div className="relative h-full overflow-hidden rounded-3xl border border-white/10 lg:rounded-[3rem] mx-1 mt-1" data-id="element-118">
          <iframe src="https://player.vimeo.com/video/1130569849?badge=0&autopause=0&player_id=0&app_id=58479&background=1&autoplay=1&loop=1&muted=1" className="absolute top-1/2 left-1/2 w-[177.77vh] h-[56.25vw] min-w-full min-h-full transform -translate-x-1/2 -translate-y-1/2" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" title="Hero Background Video" onLoad={handleIframeLoad} data-id="element-119" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-120" />
          <div className="absolute bottom-0 left-0 right-0 z-10 p-6 lg:p-12 pb-12" data-id="element-121">
            <motion.div className="max-w-2xl" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-122">
              <motion.h1 className="text-3xl md:text-4xl lg:text-5xl text-white font-medium" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.3,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-123">
                Healthcare Data,
                <br data-id="element-124" />
                Finally Aligned.
              </motion.h1>
              <motion.p className="mt-4 text-base md:text-lg text-white/90 leading-relaxed" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.4,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-125">
                We give healthcare leaders clean, connected data so patients get
                faster, safer care—and organizations scale without chaos.
              </motion.p>
              <motion.div className="mt-6 flex flex-col sm:flex-row gap-3" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.5,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-126">
                <motion.a href="https://calendly.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-12 rounded-xl pl-6 pr-4 text-sm bg-white text-black font-semibold hover:bg-white/90 transition-colors" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} data-id="element-127">
                  <span className="text-nowrap" data-id="element-128">
                    Book a 15-Minute Executive Consult
                  </span>
                  <ChevronRight className="ml-2 w-4 h-4" data-id="element-129" />
                </motion.a>
                <motion.div whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} data-id="element-130">
                  <Link to="/what-is-mdm" className="inline-flex items-center justify-center h-12 rounded-xl px-6 text-sm text-white border-2 border-white/60 hover:bg-white/10 transition-colors font-semibold" data-id="element-131">
                    <span className="text-nowrap" data-id="element-132">What is MDM?</span>
                  </Link>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}